export default new (class Tab {
    constructor() {
        this.tab = 'tab';
        this.tabItem = 'tab-menu-item:not(.tab-menu-item-link)';
        this.tabItemInited = 'tab-menu-item-inited';
        this.tabContents = 'tab-contents';
        this.tabContent = 'tab-content';

        document.addEventListener("DOMContentLoaded", () => {
            this.initHandler();
        });
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.querySelectorAll(`.${this.tabItem}`).forEach((item) => {
            if (item.classList.contains(this.tabItemInited)) return;
            item.classList.add((this.tabItemInited));
            item.addEventListener('click', (e) => {
                e.preventDefault();
                let tabId = item.getAttribute('data-tab');
                let tab = item.closest(`.${this.tab}`);

                tab.querySelectorAll(`.${this.tabItem}`).forEach((item) => {
                    item.classList.remove('active')
                });
                tab.querySelectorAll(`.${this.tabContent}`).forEach((item) => {
                    item.classList.remove('active')
                });

                item.classList.add('active')
                tab.querySelector(`.${this.tabContent}[data-tab="${tabId}"]`).classList.add('active')


                /*const container = item.closest('.tab-menu').closest('.overflow-auto')
                if(container) {
                    const offsetBottom = item.offsetLeft + item.offsetWidth;
                    const scrollBottom = container.scrollLeft + container.offsetWidth;
                    //if (offsetBottom > scrollBottom) {
                        container.scrollLeft = offsetBottom - (container.offsetWidth / 2);
                    //}
                }*/
            });
        });
    }
})()
